import UIIcon from 'UIComponents/icon/UIIcon';
import UILogo from 'UIComponents/image/UILogo';
import { getDisplayedValue } from 'customer-data-property-utils/PropertyValueDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getPaymentProcessorIcon = value => {
  switch (value) {
    case 'hs_payments':
      return /*#__PURE__*/_jsx(UIIcon, {
        "data-test-id": "processor-icon-hs_payments",
        className: "m-right-1",
        name: "sprocket",
        color: "#fb432a",
        size: 18
      });
    case 'byo_stripe':
      return /*#__PURE__*/_jsx(UILogo, {
        "data-test-id": "processor-icon-byo_stripe",
        className: "m-right-1",
        name: "stripe",
        width: 18
      });
    case 'quickbooks':
      return /*#__PURE__*/_jsx(UIIcon, {
        "data-test-id": "processor-icon-quickbooks",
        className: "m-right-1",
        name: "quickbooks",
        color: "#2ea048",
        size: 18
      });
    default:
      return null;
  }
};
const FormattedPaymentProcessor = ({
  property,
  value,
  objectTypeId,
  placeholder
}) => {
  if (value === null || value === undefined) {
    return /*#__PURE__*/_jsx("span", {
      children: placeholder
    });
  }
  return /*#__PURE__*/_jsxs("span", {
    children: [getPaymentProcessorIcon(value), getDisplayedValue(property, value, undefined, undefined, objectTypeId)]
  });
};
export default FormattedPaymentProcessor;